import styled, { css } from 'styled-components';

import { CheckboxField as FormCheckbox, TextField as TextFieldForm, Button as FormButton } from '@components/form';
import { media } from '@theme/media';
import { colonSuffix, paragraphTextStyles } from '@components/blocks/blocks.styles';
import { CONTAINER_PADDING, NARROW_CONTAINER_WIDTH } from '@components/blocks';
import { COLORS } from '@theme/colors';

export const Container = styled.div`
  margin: 0 ${CONTAINER_PADDING}px;

  ${media.tablet} {
    margin: 0 auto;
    width: calc(${NARROW_CONTAINER_WIDTH}px + ${CONTAINER_PADDING}px * 3);
  }

  ${media.desktop} {
    margin: 4.2em 0 0;
    width: auto;
    display: grid;
    grid-template-columns:
      calc((100% - ${NARROW_CONTAINER_WIDTH}px - ${CONTAINER_PADDING}px * 3) / 2)
      calc(${NARROW_CONTAINER_WIDTH}px + ${CONTAINER_PADDING}px * 3)
      auto;
  }
`;

export const Title = styled.h3`
  ${paragraphTextStyles};
  ${colonSuffix};
  font-weight: 500;
  margin-top: 2.8em;
  margin-bottom: 1.4em;
  position: relative;
  hyphens: auto;

  ${media.tablet} {
    margin-bottom: 0.7em;
  }

  ${media.desktop} {
    margin: 0;
    padding-left: ${CONTAINER_PADDING * 1.5}px;
    padding-right: ${CONTAINER_PADDING * 1.5}px;
  }
`;

const newsletterFormFontStyles = css`
  font-size: 18px;
  line-height: 1.4em;
  font-weight: 500;
  letter-spacing: normal;

  ${media.mobile} {
    font-size: 20px;
    line-height: 1.5em;
  }
`;

export const Form = styled.form``;

export const TermsConditions = styled.div``;

export const CheckboxField = styled(FormCheckbox)`
  color: ${COLORS.BLACK};

  label {
    div {
      ${newsletterFormFontStyles};
    }
  }
  input {
    margin-top: 9px;
    width: 23px;
    height: 12px;

    &:after {
      width: 6px;
      height: 6px;
    }
  }
`;

export const TextField = styled(TextFieldForm)`
  color: ${COLORS.BLACK};

  input,
  label {
    ${newsletterFormFontStyles};
  }
`;

export const Button = styled(FormButton)<{ backgroundColor: string; textColor: string }>`
  ${newsletterFormFontStyles};

  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  border-color: ${({ textColor }) => textColor};

  &:hover {
    background-color: ${({ textColor }) => textColor};
    color: ${({ backgroundColor }) => backgroundColor};
  }
`;

export const InformationText = styled.p`
  margin: 0 0 80px;
  font-size: 18px;
  line-height: 1.4em;
  
  ${media.mobile} {
    font-size: 20px;
    line-height: 1.25em;
    font-weight: 500;
    letter-spacing: normal;
  }
  }
`;
